let es = {
  translations: {
    home: {
      installer: "Installer",
      support: "Support",
      customer: "Customer",
      admin: "Admin",
    },
    login: {
      title: "Registrarse",
      username: "Username",
      password: "Password",
      button: "Regístrate",
      have_account: "Have an account?",
      sign_in: "Registrarse",
    },
    reset: {
      title: "Reset Password",
      email: "Email",
      username: "Username",
      button: "Send reset link",
      dont_remember_password: "Don't remember password? ",
      reset: "Reset",
      text: "Enter the username associated with your account, and we’ll email you a link to reset your password.",
      message:
        "A link to reset your password has been sent to your email address.",
    },
    reset_confirm: {
      title: "Actualiza Password",
      password: "Password",
      confirm_password: "Confirmar Password",
      button: "Actualizar",
      text: "",
      message: "¡Bienvenido de nuevo! Tu password ha sido actualizada.",
    },
    register: {
      tabs: {
        installer: "Installer",
        customer: "Customer",
      },
      title: "Crear nuevo account",
      first_name: "Primer nombre",
      last_name: "Apellido",
      email: "Email",
      username: "Username",
      password: "Password",
      confirm_password: "Confirmar Password",
      telephone_number: "Phone",
      cellular_number: "Mobile",
      fax_number: "Fax",
      street: "Calle",
      city: "Ciudad",
      cap: "Cap",
      district: "Provincia",
      country: "País",
      vat_number: "Vat",
      button: "Regístrate.",
      address_title: "Habla a",
      password_title: "Password",
      contact_title: "Contacto",
      account_title: "Account",
      profile_title: "Perfil",
      dont_have_account: "¿No tienes un account?",
      sign_up: "Inscribirse",
      title_edit_address: "Editar dirección",
      title_edit_profile: "Editar perfil",
      button_save: "Salvar",
    },
    support: {
      create_support: "Crear Supporto",
    },
    profile: {
      change_password: {
        title: "Cambiar Password",
        current_password: "Password actual",
        new_password: "Nueva Password",
        confirm_password: "Confirmar Password",
        button: "Salvar",
      },
      update: "ACTUALIZAR",
    },
    installations: {
      add: "Agregar Plant",
    },
    nav_menu: {
      home: "HOME",
      reserved_area: "ÁREA RESERVADA",
      link_reserved_area: "https://www.ecat.it/es/area-reservada/",
      link_home: "https://www.ecat.it/es/",
      products: "PRODUCTS",
      link_products: "https://www.ecat.it/es/productos/",
      gallery: "GALLERY",
      link_gallery: "https://www.ecat.it/es/gallery/",
      support: "ASISTENCIA",
      link_support: "https://www.ecat.it/es/asistencia/",
      contact_us: "CONTACTO",
      link_contact_us: "https://www.ecat.it/es/informacion/",
    },
    nav_menuburger: {
      home: "Home",
      reserved_area: "Área reservada",
      products: "Products",
      gallery: "Asistencia",
      support: "Support",
      contact_us: "Contacto",
      link_reserved_area: "https://www.ecat.it/es/area-reservada/",
      link_home: "https://www.ecat.it/es/",
      link_products: "https://www.ecat.it/es/productos/",
      link_gallery: "https://www.ecat.it/es/gallery/",
      link_support: "https://www.ecat.it/es/asistencia/",
      link_contact_us: "https://www.ecat.it/es/informacion/",
    },
    footer: {
      privacy_policy: "Privacy policy",
      cookies_policy: "Cookies policy",
      certification: "ISO Certification",
      company_policy: "Company policy",
      condition: "Warranty and condition",
      sales_contract: "EKlok sales contract",
      return_policy: "Return Policy",
      link_privacy_policy: "https://www.ecat.it/es/privacy-policy/",
      link_cookies_policy: "https://www.ecat.it/es/cookie/",
      link_certification: "https://www.ecat.it/src/html/doc/9001_Inglese.pdf",
      link_company_policy: "https://www.ecat.it/es/company_policy/",
      link_condition: "https://www.ecat.it/src/html/doc/sale_conditions.pdf",
      link_sales_contract:
        "https://www.ecat.it/src/html/doc/contratto_eklok_eng.pdf",
      link_return_policy:
        "https://www.ecat.it/src/html/doc/return_policy_eng.pdf",
    },
    device_frame: {
      timeout: "El tiempo de conexión expiró",
    },
    errors: {
      user_disabled: 'Cuenta deshabilitada. Contacta con el soporte.',
      http_400: "Solicitud no válida.",
      http_401: "Credenciales no válidas o sesión expirada. Inicia sesión.",
      http_403: "No tienes permisos para realizar esta acción.",
      http_404: "Recurso no encontrado.",
      http_409: "Conflicto con el estado actual del recurso.",
      http_422: "Los datos enviados no son válidos.",
      http_429: "Demasiadas solicitudes. Inténtalo de nuevo en unos momentos.",
      http_500: "Error interno del servidor. Inténtalo más tarde.",
      http_502: "Servidor no accesible. Inténtalo más tarde.",
      http_503: "Servicio temporalmente no disponible.",
      http_504: "Tiempo de espera del servidor agotado. Inténtalo más tarde.",
      network: "No se pudo contactar con el servidor. Verifica la conexión.",
      unknown: "Se ha producido un error inesperado.",
    },
  },
};

export default es;
